import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container", "template" ]

  connect() {
  }

  add(event) {
    event.preventDefault()
    const timestamp = new Date().getTime()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, timestamp)
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest('.nested-fields')
    const destroyField = item.querySelector('input[name$="[_destroy]"]')
    if (destroyField) {
      destroyField.value = 1
    }
    item.style.display = 'none'
  }
}
